var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var METADATA_KEYS = {
    SCHEMA: 'debugPanel:schema',
    GROUPS: 'debugPanel:groups',
};
function withSchema(target, cb) {
    var schema = Reflect.getMetadata(METADATA_KEYS.SCHEMA, target) || {};
    var updatedSchema = cb(schema) || schema;
    Reflect.defineMetadata(METADATA_KEYS.SCHEMA, updatedSchema, target);
}
export function title(titleText) {
    return function (target, property) {
        withSchema(target, function (schema) {
            var type = Reflect.getMetadata('design:type', target, property);
            schema[property] = __assign(__assign({}, schema[property]), { key: property, title: titleText, type: type });
            return schema;
        });
    };
}
export function group(groupName) {
    return function (target, property) {
        withSchema(target, function (schema) {
            schema[property] = __assign(__assign({}, schema[property]), { groupName: groupName });
            return schema;
        });
    };
}
export function description(descriptionString) {
    return function (target, property) {
        withSchema(target, function (schema) {
            schema[property] = __assign(__assign({}, schema[property]), { description: descriptionString });
            return schema;
        });
    };
}
export function persistent(target, property) {
    withSchema(target, function (schema) {
        schema[property] = __assign(__assign({}, schema[property]), { persistent: true });
    });
}
export function requiresReload(target, property) {
    withSchema(target, function (schema) {
        schema[property] = __assign(__assign({}, schema[property]), { requiresReload: true });
    });
}
//# sourceMappingURL=decorators.js.map